import type { ThemeMode } from '@/stores/themeStore';

export interface ChordSheetPalette {
  background: string;
  text: string;
  muted: string;
  border: string;
  chord: string;
  annotationBackground: string;
  annotationText: string;
}

export const CHORD_SHEET_PALETTES: Record<ThemeMode, ChordSheetPalette> = {
  dark: {
    background: '#0A0A0F',
    text: '#F5F5F7',
    muted: '#92929B',
    border: 'rgba(255, 255, 255, 0.12)',
    chord: '#F08A68',
    annotationBackground: 'rgba(217, 119, 6, 0.12)',
    annotationText: '#F4A340',
  },
  light: {
    background: '#FFFFFF',
    text: '#202027',
    muted: '#666671',
    border: '#E1E1E7',
    chord: '#B84324',
    annotationBackground: 'rgba(169, 85, 0, 0.1)',
    annotationText: '#9A4A00',
  },
};